import { createNgReactBridgeController } from '../../react-bridge'
import { UserAPIKeysCtrl } from './user-api-keys.controller'

// Note there are two controllers exported with the same name
// They are used in the org and superadmin portals respectively
createNgReactBridgeController('UserAPIKeysCtrl', UserAPIKeysCtrl)
